function init() {

	const htmlEl           = document.documentElement
	const elHiddenClass    = 'hidden'
	const overlayOpenClass = 'js-overlay-open'

	const toggleDetail = (el) => {

		el.classList.toggle(elHiddenClass)
		htmlEl.classList.toggle(overlayOpenClass)
	}

	for (const btn of document.querySelectorAll('[data-values-grid-button]')) {

		btn.addEventListener('click', () => {

			const el = btn.nextElementSibling
			toggleDetail(el)
		})
	}

	for (const btn of document.querySelectorAll('[data-values-grid-detail-close]')) {

		btn.addEventListener('click', () => {

			const el = btn.closest('[data-values-grid-detail]')
			toggleDetail(el)
		})
	}
}

export default init